import React, { useState, useCallback } from 'react';
import photoData from './data/photoData';

import Header from './components/Header';
import Hero from './components/Hero';
import Statement from './components/Statement';
import Gallery from './components/Gallery';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Lightbox from './components/Lightbox';

const App = () => {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const open = useCallback((i) => {
    setLightboxIndex(i);
    document.body.style.overflow = 'hidden';
  }, []);

  const close = useCallback(() => {
    setLightboxIndex(null);
    document.body.style.overflow = '';
  }, []);

  const nav = useCallback((dir) => {
    setLightboxIndex((i) => (i == null ? i : (i + dir + photoData.length) % photoData.length));
  }, []);

  return (
    <div className="bg-paper text-ink font-display selection:bg-ink selection:text-paper overflow-x-hidden">
      <Header />
      <Hero />
      <Gallery photos={photoData} onOpen={open} />
      <Statement />
      <About />
      <Contact />
      <Footer />
      {lightboxIndex != null && (
        <Lightbox photos={photoData} index={lightboxIndex} onClose={close} onNav={nav} />
      )}
    </div>
  );
};

export default App;
